import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError, overrideOrganizationHeader } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { ChildOrganization } from '@cast/types-organization-management';

import { getChildOrganizationsQueryKey } from '../queries/child-organizations-query-key';
import { ORGANIZATIONS_QUERY_KEY } from '@cast/infrastructure-organization';

type useCreateChildOrganizationMutationArgs = {
  onSuccess?: () => void;
};

export const useCreateChildOrganizationMutation = ({
  onSuccess,
}: useCreateChildOrganizationMutationArgs = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      payload: Pick<ChildOrganization, 'name'> & { enterpriseId: string }
    ) => {
      return apiClient.enterprises.createChildOrganization(
        {
          enterpriseId: payload.enterpriseId,
          createChildOrganizationRequestChildOrganization: {
            name: payload.name,
          },
        },
        {
          headers: overrideOrganizationHeader(payload.enterpriseId),
        }
      );
    },
    onError: (error: unknown) => {
      notify.error(parseApiError(error));
    },
    onSuccess: (_, payload) => {
      onSuccess?.();
      queryClient.invalidateQueries({
        queryKey: [ORGANIZATIONS_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: getChildOrganizationsQueryKey({
          enterpriseOrgId: payload.enterpriseId,
        }),
      });
    },
  });
};
